import React, { useState } from 'react';

import CreatableSelect from 'react-select/creatable';

const components = {
  DropdownIndicator: null
};

const createOption = (label) => ({
  label,
  value: label
});

export default function SelectOptions({
  theme,
  disabled,
  options,
  setOptions
}) {
  const [_inputValue, setInputValue] = useState('');

  const handleChange = (value) => {
    setOptions(value);
  };

  const handleInputChange = (inputValue) => {
    setInputValue(inputValue);
  };

  const handleKeyDown = (event) => {
    if (!_inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        setInputValue('');
        setOptions([...options, createOption(_inputValue)]);
        event.preventDefault();
    }
  };
  return (
    <CreatableSelect
      components={components}
      inputValue={_inputValue}
      theme={theme}
      isClearable
      isMulti
      menuIsOpen={false}
      onChange={handleChange}
      onInputChange={handleInputChange}
      onKeyDown={handleKeyDown}
      classNamePrefix="select"
      name="callback-react-select"
      className="react-select w-100 react-select mt-1"
      placeholder="Escribe algo para agregarlo..."
      value={options}
      isDisabled={disabled}
    />
  );
}
